import React from 'react';
import {
	Skeleton,
	type SkeletonProps,
	Typography,
	type TypographyProps,
} from '@mui/material';

export interface PrimaryTitleProps extends TypographyProps {
	loading?: boolean;
	SkeletonProps?: Partial<SkeletonProps>;
}

/**
 * NetX Primary Title
 */
const PrimaryTitlePrimitive = ({
	loading,
	variant = 'h5',
	SkeletonProps,
	...props
}: PrimaryTitleProps) => {
	if (loading && !props.children)
		return <Skeleton height={32} width="50%" {...SkeletonProps} />;
	return <Typography variant={variant} noWrap {...props} />;
};

export const PrimaryTitle = PrimaryTitlePrimitive;

export default PrimaryTitle;
